export default __webpack_public_path__ + "static/media/icon-arrow-bottom.a10482b4.svg";